import type { LocatedOsmElement } from "./types.ts";

export const OSM_SPATIAL_RANK = {
  // Strongest evidence: an area geometry covers the exact clicked coordinate.
  POLYGON_COVERS_CLICK: 0,

  // Medium evidence: a point geometry falls inside the click lookup box.
  POINT_IN_LOOKUP_BBOX: 1,

  // Weakest spatial evidence: a line geometry intersects the click lookup box.
  LINE_INTERSECTS_LOOKUP_BBOX: 2,
} as const;

export type OsmLookupElement = LocatedOsmElement & {
  spatialRank: OsmSpatialRank;
};

export type OsmSpatialRank =
  typeof OSM_SPATIAL_RANK[keyof typeof OSM_SPATIAL_RANK];

export function isOsmSpatialRank(value: number): value is OsmSpatialRank {
  return Object.values(OSM_SPATIAL_RANK).includes(value as OsmSpatialRank);
}

export function osmSpatialMatchLabel(rank: OsmSpatialRank): string {
  switch (rank) {
    case OSM_SPATIAL_RANK.POLYGON_COVERS_CLICK:
      return "polygon covers clicked coordinate";
    case OSM_SPATIAL_RANK.POINT_IN_LOOKUP_BBOX:
      return "point inside lookup bbox";
    case OSM_SPATIAL_RANK.LINE_INTERSECTS_LOOKUP_BBOX:
      return "line intersects lookup bbox";
  }
}
